import React, {Component} from 'react';
import classNames from 'classnames';
import {constants} from '@neosvoc/nv-platform-core-common';
import SliderDotMark from './SliderDotMark';
import SliderExtremeMark from './SliderExtremeMark';
import TooltipSlider from './TooltipSlider';


const decimalFormatter = (value) => {
    return value.toLocaleString(undefined, {minimumFractionDigits: 0});
};

class IntervalSliderWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {pristine: true};
        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    handleChange(value) {
        this.setState({pristine: false});
        value = Number(value.toFixed(constants.STEP_DECIMALS));
        this.props.onChange(value);
    }

    handleClick() {
        if (this.state.pristine) {
            this.handleChange(this.props.min);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.pristine !== this.props.pristine) {
            this.setState({pristine: this.props.pristine});
        }
    }

    render() {
        const marks = {
            [this.props.min]: <SliderExtremeMark
                handleClick={this.handleClick}
                value={this.props.min} text={this.props. minLabel} position="left" />,
            [this.props.max]: <SliderExtremeMark value={this.props.max} text={this.props.maxLabel} position="right" />,
        };

        for (let i = this.props.min + this.props.interval; i < this.props.max; i += this.props.interval) {
            marks[i.toString()] = <SliderDotMark />;
        }

        return (
            <div className={classNames('row interval-slider', {'nv-slider__pristine': this.state.pristine})}>
                <div className="col-12">
                    <TooltipSlider
                        onChange={this.handleChange}
                        tipProps={{overlayClassName: 'slider-tooltip'}}
                        tipFormatter={decimalFormatter}
                        min={this.props.min}
                        max={this.props.max}
                        marks={marks}
                        step={this.props.step}
                        dots
                        dotStyle={{visibility: 'hidden'}}
                        value={this.state.pristine? this.props.min: this.props.value}
                        handleClick={this.handleClick}
                    />
                </div>
                {this.props.children}
            </div>
        );
    }
}

export default IntervalSliderWidget;
